/********************************************************************************************
 * Title: Cart Subscription Shipping
 *
 * Description:
 * Checks if the cart contains a subscription, if so, displays the UpCart app free shipping notification
 *
 * @author Alexander Khost
 ********************************************************************************************/
function freshCartContainsSubscription() {
    $0.getJSON('/cart.js', function (data ) {
        var cartContainsSubscription = false;
        for(let x = 0; x < data.items.length; x++) {
            //if there is a selling plan allocation, there is a subscription present in the cart
            if (data.items[x].selling_plan_allocation !== undefined) {
                cartContainsSubscription = true;
                break;
            }
        }
        //if the cart contains a subscription, show the UpCart free shipping notification
        let upCart = $0("#upCart");
        let upCartShadowRoot = $0(upCart)[0].shadowRoot; 
        if(cartContainsSubscription) {
            $0(upCartShadowRoot).find("#UpcartPopup").addClass('cart-contains-subscription');
        } else {
            $0(upCartShadowRoot).find("#UpcartPopup").removeClass('cart-contains-subscription');
        }
        //reset quantity and trash cart button listeners
        $0(upCartShadowRoot).find('#UpcartPopup .Stack svg, #UpcartPopup .Stack button').on('click', function() {
            setTimeout(() => {
                freshCartContainsSubscription();
            }, "500");
        });
    });
}

$0(document).ready(function() {
    //check for free shipping onload
    freshCartContainsSubscription();
    //check for free shipping when a product has been added to the cart
    $0('.purchase-button').on('click', function() { 
        setTimeout(() => {
            freshCartContainsSubscription();
        }, "500");
    });
});